/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import CaseStudiesChildFooter from "./CaseStudiesChildFooter";
import ic_hammer_big_circle from "../../assets/images/pictures/icon/ic_baseline-hammer_big_circle-64px.svg";
import ic_paper_circle from "../../assets/images/pictures/icon/ic_paper_circle.svg";
import ic_shopping_cart_circle from "../../assets/images/pictures/icon/ic_outline-shopping_cart_circle-40px.svg";
import ic_folder_circle from "../../assets/images/pictures/icon/ic_folder_shared_circle_circle.svg";
import { motion } from "framer-motion";
import routeVariants from "../../assets/animates/routeVariants";
import { useTranslation } from "react-i18next";
import Footer from "../../components/global/Footer";
import list from "../../assets/images/logos/case/doclist.png";
import cover from "../../assets/images/logos/case/cover-legal.png";
import NavbarBottom from "../../components/global/NavbarBottom";

const CaseStudiesLegalContent = () => {
  const { t } = useTranslation();

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 no-transform"
    >
      <header className="header--absolute"></header>

      <div className="procurement mt-50">
        <div className="container">
          <div className="row">
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 header">
              <img
                className="header__ic"
                src={ic_hammer_big_circle}
                alt=""
                data-no-retina=""
              />
              <h2>
                {t(
                  "case-studies-legal-page.case-studies-legal-page-content.content-1.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-legal-page.case-studies-legal-page-content.content-1.description"
                )}
              </p>
            </div>
            <div className="col-xs-12">
              <img
                className="img-responsive"
                src={list}
                alt="Example of GoPaperless document list"
              />
            </div>
          </div>
          <div className="row stages">
            <div className="col-xs-12 col-sm-8 col-sm-offset-2">
              <h2>
                {t(
                  "case-studies-legal-page.case-studies-legal-page-content.content-2.heading"
                )}
              </h2>
            </div>
            <div className="col-xs-12 col-sm-10 col-sm-offset-1 mb-10">
              <p>
                {t(
                  "case-studies-legal-page.case-studies-legal-page-content.content-2.description"
                )}
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-4 stages-legal__box pl-md-0">
              <img src={ic_paper_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-legal-page.case-studies-legal-page-content.content-2.small-heading-1"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-legal-page.case-studies-legal-page-content.content-2.small-description-1"
                  )}
                </p>
              </div>
            </div>
            <div className="col-sm-4 stages-legal__box">
              <img src={ic_shopping_cart_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-legal-page.case-studies-legal-page-content.content-2.small-heading-2"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-legal-page.case-studies-legal-page-content.content-2.small-description-2"
                  )}
                </p>
              </div>
            </div>
            <div className="col-sm-4 stages-legal__box">
              <img src={ic_folder_circle} alt="" data-no-retina="" />
              <div className="stages-legal__box__text">
                <h3>
                  {t(
                    "case-studies-legal-page.case-studies-legal-page-content.content-2.small-heading-3"
                  )}
                </h3>
                <p>
                  {t(
                    "case-studies-legal-page.case-studies-legal-page-content.content-2.small-description-3"
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="row about-pro">
            <div className="col-sm-5 pl-md-0">
              <img
                className="img-responsive"
                src={cover}
                alt="Thumbnail pages of Legal Teams and GoPaperless: A White Paper"
              />
            </div>
            <div className="col-sm-7">
              <h2>
                {t(
                  "case-studies-legal-page.case-studies-legal-page-content.content-3.heading"
                )}
              </h2>
              <p>
                {t(
                  "case-studies-legal-page.case-studies-legal-page-content.content-3.description-1"
                )}
              </p>
              <p>
                {t(
                  "case-studies-legal-page.case-studies-legal-page-content.content-3.description-2"
                )}
              </p>
              <a
                className="btn-secondary"
                href="javascript:;"
                data-toggle="modal"
                data-target="#download-book"
              >
                {t(
                  "case-studies-legal-page.case-studies-legal-page-content.content-3.button-access"
                )}
              </a>
            </div>
          </div>
        </div>
        <CaseStudiesChildFooter />
      </div>
      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default CaseStudiesLegalContent;
